
import "leaflet/dist/leaflet.css";
import { BaseMapComponent } from "./map";

export default class MapComponent extends BaseMapComponent {}
